import example from 'assets/example.jpg';
import { SiteMaterialQualityReport } from 'features';
import { useTranslation } from 'i18n';
import { useParams } from 'react-router-dom';
import { Button, Stack } from 'ui';

export const InternalQualityReport = () => {
  const { t } = useTranslation('orders');
  const { siteMaterialId } = useParams<{ siteMaterialId: string }>();

  if (siteMaterialId === undefined) {
    throw new Error(t('internalQualityReport.errors.materialNotFound'));
  }

  const handleClick = () => {
    window.open(`/report/${siteMaterialId}`, '_blank');
  };

  return (
    <>
      <Stack
        sx={{
          textAlign: 'right',
          py: 2,
        }}
      >
        <Button onClick={handleClick}>{t('internalQualityReport.actions.linkToPublicQualityReport')}</Button>
      </Stack>
      <SiteMaterialQualityReport
        siteMaterialId={String(siteMaterialId)}
        placeholderSrc={example}
        source="QUALITY_REPORT"
      />
    </>
  );
};
